import { Button } from '@cian/ui-kit/button';
import { FC } from 'react';

import styles from './ModalErrorContent.css';

interface IErrorContentProps {
  text?: string;
  onRetry(): void;
}

export const ModalErrorContent: FC<IErrorContentProps> = ({ text, onRetry }) => {
  return (
    <div className={styles['container']}>
      <p className={styles['text']}>
        {text ||
          'Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.'}
      </p>
      <Button onClick={onRetry}>Повторить</Button>
    </div>
  );
};
